import {VenueRoutes as SharedRoutes} from 'Shared/routes/VenueRoutes';
import { RoutesType } from 'Shared/Routes';
import { lazy } from 'solid-js';


export class TheTownieRoutes extends SharedRoutes
{
	frontend()
	{
		return ({
			...super.frontend(),

			//FIXME replace these with redirects (need to reimplement these as a possibility)

			'/members':		lazy(() => import('Shared/frontend/membersPage/MembersPage')),

			/* Printed QR codes link to this */
			'/clubtownie':	lazy(() => import('Shared/frontend/membersPage/MembersPage')),

			/* The townies Google profile has their menu linked to townhallhotelnewtown.com/food/ (the slash is required) */
			'/food':	lazy(() => import('Shared/frontend/menuPage/MenuPage')), 	//TODO {slug:'menu'},
		}) as RoutesType;
	}

	backend()
	{
		return ({
			...super.backend(),
		}) as RoutesType;
	}
}

